<template>
  <div class="newsInformation">
    <detailsTop :topIndex="topIndex" />
    <div class="news-content">
      <div class="new-center">
        <bannerTips
          :bannerTipsList="bannerTipsList"
          :bannerIndex="4"
          @changeTips="changeTips"
        />

        <div class="exhibition-item-info">
          <div class="info-title">
            <div class="info-left"></div>
            <div class="info-right">留言提交</div>
          </div>
          <div class="info-line"></div>
          <div class="info-concent">
            <el-form
              :model="form"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="用户名:" prop="name">
                <el-input
                  v-model="form.name"
                  placeholder="请输入内容"
                ></el-input>
              </el-form-item>
              <el-form-item label="意见:" prop="opinion">
                <el-input
                  v-model="form.opinion"
                  type="textarea"
                  rows="5"
                  placeholder="请输入内容"
                ></el-input>
              </el-form-item>
              <el-form-item label="电话:" prop="phone">
                <el-input
                  v-model="form.phone"
                  placeholder="请输入内容"
                ></el-input
              ></el-form-item>

              <el-form-item class="message-btn">
                <el-button
                  class="submit-btn"
                  type="primary"
                  @click="submitClick('ruleForm')"
                  >提交</el-button
                >
                <el-button class="reset-btn" @click="resetClick('ruleForm')"
                  >重置</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <pageBottom />
  </div>
</template>

<script>
import detailsTop from "@/components/detailsTop.vue";
import pageBottom from "@/components/pageBottom";
import bannerTips from "@/components/bannerTips";
import { addTMessageArea } from "@/api/api.js";

export default {
  name: "news",
  components: {
    detailsTop,
    pageBottom,
    bannerTips,
  },
  data() {
    return {
      bannerTipsList: [],
      topIndex: 6,
      form: {
        name: "",
        opinion: "",
        phone: "",
      },
      bannerIndex: 0,
      rules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        opinion: [{ required: true, message: "请输入意见", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入电话", trigger: "blur" },
          { min: 11, max: 11, message: "长度在 11 个字符", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.bannerTipsList = JSON.parse(localStorage.getItem("bannerList"));

    this.$route.query.bannerIndex
      ? (this.bannerIndex = this.$route.query.bannerIndex)
      : (this.bannerIndex = 0);
    this.$route.query.topIndex
      ? (this.topIndex = this.$route.query.topIndex)
      : (this.topIndex = 6);
  },

  methods: {
    changeTips(index) {
      switch (index) {
        case 0:
          this.$router.push({ name: 'contactUS', query: { bannerIndex: index } })
          break

        case 1:
          this.$router.push({ name: 'aftersales', query: { bannerIndex: index } })

          break
        case 2:
          this.$router.push({ name: 'support', query: { bannerIndex: index } })

          break
        case 3:
          this.$router.push({ name: 'join', query: { bannerIndex: index } })
          break
        case 4:
          this.$router.push({ name: 'message', query: { bannerIndex: index } })
          break
      }
      localStorage.setItem("bannerList", JSON.stringify(this.bannerTipsList));
    },
    resetClick(formName) {
      this.$refs[formName].resetFields();
    },
    submitClick(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const { data } = await addTMessageArea(this.form);
          if (data.code === 200) {
            this.$message({
              message: data.msg,
              type: "success",
            });
          } else {
            this.$message.error(data.msg);
          }
        } else {
          this.$message.error("请填写完整信息");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.news-content {
  width: 86%;
  max-width: 1440px;
  margin: 20px auto;
  height: 100%;


  .new-center {
    // flex: 5.3;
    background: #f4f4f4;

    .exhibition-item-info {
      width: 100%;
      background: #ffffff;
      margin: 20px 0;
      text-align: left;
      padding-bottom: 20px;
      .info-title {
        display: flex;
        align-items: center;
        padding-top: 25px;
        padding-left: 26px;

        .info-left {
          width: 5px;
          height: 28px;
          background: #46739f;
        }

        .info-right {
          font-size: 24px;
          font-weight: bold;
          color: #333333;
          margin-left: 16px;
        }
      }

      .info-line {
        width: 96%;
        margin: 0 auto;
        height: 1px;
        background: #eeeeee;
        margin-top: 25px;
      }

      .info-concent {
        width: 40%;
        margin: 3.5% auto;

        .message-wrap {
          display: flex;
          align-items: center;
          margin-bottom: 20px;

          .message-title {
            width: 70px;
          }
        }

        .message-btn {
          display: flex;
          margin-top: 80px;
          justify-content: space-between;
          .submit-btn {
            width: 160px;
            height: 47px;
            text-align: center;
            background: #46739f;
            color: #ffffff;
            cursor: pointer;
            border: none;
          }

          .reset-btn {
            border: none;

            width: 160px;
            text-align: center;
            height: 47px;
            color: #ffffff;
            background: #b6b6b6;
            cursor: pointer;
          }
        }
      }

      .info-table {
        width: 90%;
        margin: 4% auto;
        display: flex;
        justify-content: left;
        flex-wrap: wrap;
        align-items: center;

        .table-title {
          width: 20%;
          height: 54px;
          line-height: 54px;
          background: #f4f4f4;
          text-align: center;
          border: 1px solid #e0e0e0;
        }

        .table-content {
          width: 29.6%;
          height: 54px;
          line-height: 54px;
          text-align: center;
          background: #ffffff;
          border: 1px solid #e0e0e0;
        }
      }
    }
  }



  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #46739f;
    color: #fff;
  }
}

@media only screen and (max-width: 1550px) {


  .new-center {
    flex: 12 !important;
    background: #f4f4f4;
  }


}
</style>
